export const slugifyName = (name: string) => {
  return name
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
};

/**
 * Builds a stable slug for a station using its display name and id.
 * We append the id after a double-dash so we can reliably map back to the backend id.
 */
export const makeStationSlug = (station: { id: string; name: string }) => {
  const namePart = slugifyName(station.name);
  const idPart = encodeURIComponent(station.id);
  return `${namePart}--${idPart}`;
};

/**
 * Extract the station id (if present) from a slug built with makeStationSlug.
 */
export const stationIdFromSlug = (slug: string) => {
  const parts = slug.split("--");
  if (parts.length > 1) {
    const raw = parts[parts.length - 1];
    try {
      return decodeURIComponent(raw);
    } catch {
      return raw;
    }
  }
  return null;
};

/**
 * Extract a best-effort station name fragment from a slug for fallback lookup.
 */
export const stationNameFromSlug = (slug: string) => {
  const parts = slug.split("--");
  const namePart = parts[0] || slug;
  return namePart.replace(/-/g, " ").trim();
};
